import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-159">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-160" />

      <div className="relative w-full max-w-3xl max-h-[90vh] bg-[#1a1a1a] border border-brand-amber/20 rounded-2xl shadow-2xl flex flex-col" data-id="element-161">
        <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-162">
          <h2 className="text-2xl font-serif font-bold text-brand-offwhite" data-id="element-163">
            Términos y Condiciones
          </h2>
          <button onClick={onClose} className="p-2 text-brand-offwhite/50 hover:text-brand-offwhite hover:bg-white/5 rounded-full transition-colors" data-id="element-164">
            <X className="w-5 h-5" data-id="element-165" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto custom-scrollbar text-brand-offwhite/80 space-y-6 text-sm leading-relaxed" data-id="element-166">
          <section data-id="element-167">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-168">
              1. Introducción
            </h3>
            <p data-id="element-169">
              Bienvenido a "Después del Engaño". Al comprar y acceder a nuestro
              producto digital, usted acepta estar sujeto a estos Términos y
              Condiciones. Por favor, léalos cuidadosamente antes de realizar su
              compra.
            </p>
          </section>

          <section data-id="element-170">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-171">
              2. Producto Digital
            </h3>
            <p data-id="element-172">
              "Después del Engaño" es un producto digital (eBook/guía) entregado
              en formato electrónico. Al completar su compra por $6.36 USD,
              recibirá acceso inmediato para descargar o visualizar el
              contenido.
            </p>
          </section>

          <section data-id="element-173">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-174">
              3. Uso Personal y Derechos de Autor
            </h3>
            <p data-id="element-175">
              El contenido de este producto está protegido por derechos de
              autor. Su compra le otorga una licencia personal, no exclusiva e
              intransferible para usar el material. Queda estrictamente
              prohibido:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-176">
              <li data-id="element-177">Compartir, revender o redistribuir el material.</li>
              <li data-id="element-178">Copiar o reproducir el contenido para fines comerciales.</li>
              <li data-id="element-179">Publicar el contenido en internet o redes sociales.</li>
            </ul>
          </section>

          <section data-id="element-180">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-181">
              4. Política de Reembolso
            </h3>
            <p data-id="element-182">
              Debido a la naturaleza digital del producto y el acceso inmediato
              al contenido, todas las ventas son finales. Sin embargo, si
              experimenta problemas técnicos para acceder al material, por favor
              contáctenos para brindarle asistencia.
            </p>
          </section>

          <section data-id="element-183">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-184">
              5. Descargo de Responsabilidad Médica/Psicológica
            </h3>
            <p data-id="element-185">
              El contenido de "Después del Engaño" tiene fines puramente
              informativos y educativos. No sustituye el consejo, diagnóstico o
              tratamiento profesional de un psicólogo, psiquiatra o terapeuta
              calificado. Si se encuentra en una crisis emocional severa, busque
              ayuda profesional de inmediato.
            </p>
          </section>

          <section data-id="element-186">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-187">
              6. Pagos
            </h3>
            <p data-id="element-188">
              Los pagos se procesan de forma segura a través de nuestros
              proveedores de pago. El cargo en su tarjeta aparecerá de forma
              discreta para proteger su privacidad.
            </p>
          </section>

          <section data-id="element-189">
            <h3 className="text-lg font-bold text-brand-amber mb-2" data-id="element-190">
              7. Modificaciones
            </h3>
            <p data-id="element-191">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en el sitio web.
            </p>
          </section>
        </div>
      </div>
    </div>;
}